import axios from 'axios';

// Aparte client voor het publieke klantenportaal.
// Gebruikt een EIGEN token (portal_token) en logt NIET uit bij 401.
const portalApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

portalApi.interceptors.request.use(config => {
  const t = localStorage.getItem('portal_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function setPortalToken(t) {
  if (t) localStorage.setItem('portal_token', t);
}

export function clearPortalToken() {
  localStorage.removeItem('portal_token');
}

export default portalApi;
